import {
  CACHE_CONTROL_KEY,
  EMPLOYEE_NOTIFICATION,
  LOCATION_SOURCE,
  REGION,
  REGION_NAME,
  ZIP_CODE,
} from '@/utils/constants/cookies';
import {
  FIVE_YEARS_IN_MINUTES,
  TWELVE_HOURS_IN_MINUTES,
  ONE_HOUR_IN_MINUTES,
  SIX_MONTHS_IN_MINUTES,
} from '@/utils/constants/time';
import { addMinutesToDate } from '@/utils/date/add-minutes';

import { type CookieOptions } from '../types';

interface CookiesDefaultOptions extends Omit<CookieOptions, 'name' | 'value'> {}

interface CookiesMandatoryOptions {
  [key: string]: CookiesDefaultOptions;
}

interface CreateCookieOptions {
  (options: CookieOptions): CookieOptions;
}

const defaultOptions: CookiesDefaultOptions = {
  domain: undefined,
  expires: addMinutesToDate(new Date(), FIVE_YEARS_IN_MINUTES),
  httpOnly: false,
  path: '/',
  sameSite: 'strict',
  secure: true,
};

const cookiesMandatoryOptions: CookiesMandatoryOptions = {
  [CACHE_CONTROL_KEY]: {
    expires: addMinutesToDate(new Date(), ONE_HOUR_IN_MINUTES),
    httpOnly: true,
    domain: process.env.NEXT_PUBLIC_SHARED_COOKIE_DOMAIN,
  },
  [EMPLOYEE_NOTIFICATION]: {
    expires: addMinutesToDate(new Date(), TWELVE_HOURS_IN_MINUTES),
  },
  [REGION]: {
    domain: process.env.NEXT_PUBLIC_SHARED_COOKIE_DOMAIN,
  },
  [REGION_NAME]: {
    domain: process.env.NEXT_PUBLIC_SHARED_COOKIE_DOMAIN,
  },
  [LOCATION_SOURCE]: {
    domain: process.env.NEXT_PUBLIC_SHARED_COOKIE_DOMAIN,
  },
  [ZIP_CODE]: {
    expires: addMinutesToDate(new Date(), SIX_MONTHS_IN_MINUTES),
  },
};

export const createOptions: CreateCookieOptions = (options) => ({
  ...defaultOptions,
  ...options,
  ...(cookiesMandatoryOptions[options.name] || {}),
});

export const createRemoveOptions = (name: CreateCookieOptions['name']) => {
  const mandatoryOptions = cookiesMandatoryOptions[name] || {};

  const domain =
    'domain' in mandatoryOptions
      ? mandatoryOptions.domain
      : defaultOptions.domain;

  return {
    name,
    domain,
    value: '',
    expires: 0,
  };
};
